import { Skeleton } from '@mui/material';

import Table from '@experimental-components/Table';

import useStyles, { RowStyled } from './styles';
import type { SkeletonProps } from './types';

const StripedSkeleton = ({ rows = 5, disabledStrip = false }: SkeletonProps) => {
  const classes = useStyles();

  return (
    <Table.Body>
      {Array.from(Array(rows).keys()).map((item) => (
        <RowStyled className={disabledStrip ? undefined : classes.oddRow} key={item}>
          <Skeleton height={18} variant="text" width={120} />
          <Skeleton height={18} variant="text" width={80} />
        </RowStyled>
      ))}
    </Table.Body>
  );
};

export default StripedSkeleton;
